import styled from 'styled-components';
import Modal from 'react-bootstrap/Modal';

const Header = styled(Modal.Header)`
  height: 0px;
  display: flex;
  justify-content: flex-end;
`;

export default Header;
